var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-pagination',{staticClass:"omapi-campaign-table__pagination",attrs:{"perPage":_vm.perPage,"pageTotal":_vm.campaigns.length,"total":_vm.totalFilteredCampaignsCount,"page":_vm.page},on:{"changePage":_vm.changePage}})}
var staticRenderFns = []

export { render, staticRenderFns }